<template>
  <div class="pa-2">
    <section class="cargo-hierarchy-card">
      <div class="pa-4">
        <v-card-text class="d-flex justify-space-between pa-0 pb-3" style="font-size: 1rem">
          <div class="d-flex">
            <div class="mr-4">
              <span class="font-weight-bold"> Carga: </span>
              <span class="font-weight-regular"> {{ cargo.cargoNumber || cargo.CargoNumber }} </span>
            </div>
            <div v-if="cargo.isDirectDelivery || cargo?.IsDirectDelivery" class="mr-4">
              <span class="font-weight-bold">Entrega Direta</span>
            </div>
            <div v-else class="mr-4">
              <span class="font-weight-bold">Transbordo: </span>
              <TruncateDataWithTooltip
                :data="cargo.transhipmentName || cargo.TranshipmentName"
                :lengthDataToTruncate="truncateLimit"
              ></TruncateDataWithTooltip>
            </div>
            <div v-if="!cargo.isDirectDelivery || cargo?.IsDirectDelivery == false" class="mr-4">
              <span class="font-weight-bold">Cidade: </span>
              <span class="font-weight-">{{ cargo.transhipmentCity || cargo.TranshipmentCity }}</span>
            </div>
          </div>
          <div class="d-flex">
            <v-icon @click="toggleCollapsed">
              {{ isCollapsed ? 'mdi-chevron-right' : 'mdi-chevron-down' }}
            </v-icon>
          </div>
        </v-card-text>

        <v-card-text class="d-flex pa-0">
          <v-col class="pa-0" cols="12" md="12">
            <span
              v-if="!cargo.isDirectDelivery || cargo.IsDirectDelivery == false"
              class="font-weight-bold text--secondary"
              >Frete do transbordo:
            </span>
            <span v-if="!cargo.isDirectDelivery || !cargo.IsDirectDelivery" class="font-weight-regular mr-4">{{
              formatPrice(cargo.totalTranshipmentPrice || cargo.TotalTranshipmentPrice || 0)
            }}</span>
            <span class="font-weight-bold text--secondary">Frete embarcador: </span>
            <span class="font-weight-regular mr-4">{{
              formatPrice(cargo.totalPriceDeliveries || cargo.TotalPriceDeliveries)
            }}</span>
            <span class="font-weight-bold text--secondary">Valor das mercadorias: </span>
            <span class="font-weight-regular mr-4">{{
              formatPrice(cargo.totalPriceNfes || cargo.TotalPriceNfes)
            }}</span>
            <span class="font-weight-bold text--secondary">Peso: </span>
            <span class="font-weight-regular mr-4"
              >{{ formatWeight(cargo.weightDeliveries || cargo.WeightDeliveries || 0) }}kg</span
            >
            <span class="font-weight-bold text--secondary">Quantidade de paradas: </span>
            <span class="font-weight-regular"> {{ cargo?.amountStops || cargo.AmountStops }} </span>
          </v-col>
        </v-card-text>
      </div>
      <div v-if="!isCollapsed">
        <StopHierarchyCard
          v-for="item in alocatedStops"
          :importedSuccessfully="importedSuccessfully"
          :stop="item"
          :key="item.id"
        />
      </div>
      <v-progress-linear v-if="isLoadingAlocated" indeterminate color="primary" class="mr-2"></v-progress-linear>
    </section>
  </div>
</template>

<script>
import TruncateDataWithTooltip from '@/components/Table/TruncateDataWithTooltip.vue';
import StopHierarchyCard from '@/components/ManualBoardingImport/Stepper/Step7/HierarchyDetails/StopHierarchyDetails.vue';
import maskPrice from '@/utils/maskPrice';
import copyToClipboard from '@/utils/copyToClipboard';
import maskWeight from '@/utils/maskWeight';
import { mapActions } from 'vuex';

export default {
  components: {
    TruncateDataWithTooltip,
    StopHierarchyCard
  },
  props: {
    cargo: {
      default: () => ({}),
      type: Object
    },
    importedSuccessfully: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    isLoadingAlocated: false,
    isCollapsed: true,
    alocatedStops: []
  }),
  computed: {
    truncateLimit() {
      const width = this.$vuetify.breakpoint.width;
      if (width < 1360) return 8;
      if (width < 1440) return 10;
      if (width < 1520) return 16;
      if (width < 1680) return 20;
      if (width < 1820) return 26;
      return 34;
    }
  },
  methods: {
    ...mapActions('ImportManualCargosStore', ['getStopsByCargoId', 'allocateStop']),
    async toggleCollapsed() {
      if (!this.isCollapsed) {
        this.isCollapsed = true;
      } else {
        this.isLoadingAlocated = true;
        try {
          if (this.importedSuccessfully) {
            this.alocatedStops = this.cargo.StopsTemp;
          } else {
            const data = await this.getStopsByCargoId(this.cargo.id);
            this.alocatedStops = data;
          }
          this.isCollapsed = false;
        } catch (err) {
          console.error(err);
        } finally {
          this.isLoadingAlocated = false;
        }
      }
    },
    formatPrice(price) {
      return maskPrice(price);
    },
    formatWeight(price) {
      return maskWeight(price);
    },
    copy(str) {
      copyToClipboard(str);
    }
  }
};
</script>

<style scoped>
.cargo-hierarchy-card {
  min-width: 560px;
  width: 100%;
  min-height: 90px;
  height: auto;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
</style>
